import React from "react";
import { useReveal } from "../lib/useReveal";

export default function Reveal({ children, className = "", delay = 0 }) {
  const { ref, inView } = useReveal();
  const delayClass = delay ? `reveal--delay${delay}` : "";
  return (
    <div
      ref={ref}
      className={`reveal ${
        inView ? "reveal--in" : ""
      } ${delayClass} ${className}`}
    >
      {children}
    </div>
  );
}
